import React, { ReactElement } from 'react';
import { withMe } from './MeUserWrapper';
import { MeType } from '../models/me';

const StaffOnlyWrapper = (
  { children, me }: { children: ReactElement | ReactElement[], me: MeType },
) => {
  const localConfig = localStorage.getItem('test-components-config');
  const debugConfig = localConfig && JSON.parse(localConfig);
  const { debugAcl } = debugConfig || {};

  return (
    <div className={debugAcl ? 'staff-only-debug' : ''} title="Staff only component">
      {me.isStaff && children || null}
    </div>
  );
}

export default withMe(StaffOnlyWrapper);
